import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import { CircularProgress } from '@material-ui/core/';
import { I18nextProvider } from 'react-i18next';
import { ThemeProvider } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';
import i18n from '../i18n';
import AppFrame from './AppFrame';
import HomePage from './HomePage';
import PublicSurveySubmissionPage from './consultationSurveys/PublicSurveySubmissionPage';
import BudgetApplicationFormPage from './budget/BudgetApplicationFormPage';
import BudgetVotePage from './budget/BudgetVotePage';
import BudgetManualVotePage from './budget/BudgetManualVotePage';
import BudgetManualApplicationFormPage from './budget/BudgetManualApplicationFormPage';

import SignInPage from './auth/signIn/SignInPage';
import RegistrationPage from './auth/registration/RegistrationPage';
import AccountActivationPage from './auth/accountActivation/AccountActivationPage';
import PasswordRecoveryPage from './auth/passwordRecovery/PasswordRecoveryPage';
import PasswordResetPage from './auth/passwordReset/PasswordResetPage';
import UserProfilePage from './userProfile/UserProfilePage';

import BudgetSignInPage from './budgetAuth/signIn/SignInPage';
import BudgetRegistrationPage from './budgetAuth/registration/RegistrationPage';
import BudgetAccountActivationPage from './budgetAuth/accountActivation/AccountActivationPage';
import BudgetPasswordRecoveryPage from './budgetAuth/passwordRecovery/PasswordRecoveryPage';
import BudgetPasswordResetPage from './budgetAuth/passwordReset/PasswordResetPage';
import BudgetUserProfilePage from './userProfile/BudgetUserProfilePage';

import BoardThreadPage from './consultationSurveys/board/BoardThreadPage';
import NotFoundPage from './NotFoundPage';
import routePaths from '../routePaths';
import { actions as authActions } from '../actions/authActions';
import { actions as budgetAuthActions } from '../actions/budgetAuthActions';
/*eslint import/no-unresolved:0*/
import NotificationsHandler from './notifications/NotificationsHandler';
import './AppStyles.scss';
import ParticipantApplicationsPage from './budget/ParticipantApplicationsPage';
import ParticipantVotesPage from './budget/ParticipantVotesPage';
import BudgetApplicationListOfSupportPage from './budget/BudgetApplicationListOfSupportPage';
import PublicSurveySubmissionVerificationPage from './consultationSurveys/PublicSurveySubmissionVerificationPage';

class App extends React.Component {
  constructor() {
    super();
  }

  componentDidMount() {
    if (this.props.auth.signedIn) this.props.authActions.getCurrentUserData();
    if (this.props.budgetAuth.signedIn) this.props.budgetAuthActions.getCurrentUserData();
  }

  renderAppContent(location) {
    const returnTo = encodeURIComponent(location.pathname + (location.hash ? location.hash : ''));

    return (
      <AppFrame unit={this.props.cms} tenant={this.props.unit}>
        <Switch>
          <Route exact path={routePaths.home} component={HomePage} />
          
          {!this.props.auth.signedIn ? <Route path={routePaths.signIn} component={SignInPage} /> : null}
          {!this.props.auth.signedIn ? <Route path={routePaths.registration} component={RegistrationPage} /> : null}
          {!this.props.auth.signedIn ? <Route path={routePaths.accountActivation} component={AccountActivationPage} /> : null}
          {!this.props.auth.signedIn ? <Route path={routePaths.passwordRecovery} component={PasswordRecoveryPage} /> : null}
          {!this.props.auth.signedIn ? <Route path={routePaths.passwordReset} component={PasswordResetPage} /> : null}

          {!this.props.budgetAuth.signedIn ? <Route path={routePaths.budgetAuth.signIn} component={BudgetSignInPage} /> : null}
          {!this.props.budgetAuth.signedIn ? <Route path={routePaths.budgetAuth.registration} component={BudgetRegistrationPage} /> : null}
          {!this.props.budgetAuth.signedIn ? <Route path={routePaths.budgetAuth.accountActivation} component={BudgetAccountActivationPage} /> : null}
          {!this.props.budgetAuth.signedIn ? <Route path={routePaths.budgetAuth.passwordRecovery} component={BudgetPasswordRecoveryPage} /> : null}
          {!this.props.budgetAuth.signedIn ? <Route path={routePaths.budgetAuth.passwordReset} component={BudgetPasswordResetPage} /> : null}

          {this.props.auth.signedIn ? <Route path={routePaths.userProfile} component={UserProfilePage} /> : null}

          <Route exact path={routePaths.consultations + ':id'} component={PublicSurveySubmissionPage} />
          <Route exact path={routePaths.consultations + ':id/podglad'} component={PublicSurveySubmissionPage} />
          <Route exact path={routePaths.consultations + ':id/weryfikacja/:submissionId'} component={PublicSurveySubmissionVerificationPage} />
          <Route path={routePaths.board} component={BoardThreadPage} />

          <Route path={routePaths.budgetForm + ':id'} component={BudgetApplicationFormPage} />
          <Route path={routePaths.budgetVote + ':id'} component={BudgetVotePage} />
          <Route path={routePaths.budgetManualVote + ':id'} component={BudgetManualVotePage} />
          <Route path={routePaths.budgetFormManualVote + ':id'} component={BudgetManualApplicationFormPage} />
          <Route path={routePaths.budgetListOfSupport} component={BudgetApplicationListOfSupportPage} />

          {this.props.budgetAuth.signedIn ? <Route path={routePaths.budgetAuth.userProfile} component={BudgetUserProfilePage} /> : null}
          {this.props.budgetAuth.signedIn ? <Route path={routePaths.budgetSavedApplication} component={BudgetApplicationFormPage} /> : null}
          {this.props.budgetAuth.signedIn ? <Route path={routePaths.myBudgetApplications} component={ParticipantApplicationsPage} /> : null}
          {this.props.budgetAuth.signedIn ? <Route path={routePaths.myBudgetVotes} component={ParticipantVotesPage} /> : null}
          
          {location.pathname.startsWith('/budzet')
            ? <Redirect to={`${routePaths.budgetAuth.signIn}?returnTo=${returnTo}`} push />
            : <Redirect to={`${routePaths.signIn}?returnTo=${returnTo}`} push />}
        </Switch>
        
        <NotificationsHandler />
      </AppFrame>
    );
  }

  renderAuthorizedAppContent() {
    return (
      <AppFrame unit={this.props.cms} tenant={this.props.unit}>
        <Switch>
          <Route exact path={routePaths.home} component={HomePage} />

          <Route exact path={routePaths.consultations + ':id'} component={PublicSurveySubmissionPage} />
          <Route exact path={routePaths.consultations + ':id/podglad'} component={PublicSurveySubmissionPage} />
          <Route path={routePaths.board} component={BoardThreadPage} />
          <Route path={routePaths.budgetForm + ':id'} component={BudgetApplicationFormPage} />
          <Route path={routePaths.budgetVote + ':id'} component={BudgetVotePage} />
          <Route path={routePaths.budgetManualVote + ':id'} component={BudgetManualVotePage} />
          <Route path={routePaths.budgetFormManualVote + ':id'} component={BudgetManualApplicationFormPage} />

          <Route path={routePaths.userProfile} component={UserProfilePage} />

          <Route path={routePaths.budgetSavedApplication} component={BudgetApplicationFormPage} />
          <Route path={routePaths.myBudgetApplications} component={ParticipantApplicationsPage} />
          <Route path={routePaths.myBudgetVotes} component={ParticipantVotesPage} />
        </Switch>
        <NotificationsHandler />
      </AppFrame>
    );
  }

  render() {
    return (
      <ThemeProvider theme={this.props.theme}>
        <I18nextProvider i18n={i18n}>
          {!this.props.unit || !this.props.cms ? <div style={{ width: '100%', marginTop: 200, textAlign: 'center' }}><CircularProgress size={50} /></div> :
            this.props.unit.isActive
              ? this.renderAppContent(this.props.location) /*this.props.auth.signedIn ? this.renderAuthorizedAppContent() : this.renderAppContent(this.props.location)*/
              : <NotFoundPage />
          }
          {this.props.cms && this.props.cms.font === 'made'
            ? <link rel="stylesheet" type="text/css" href={`https://${window.location.hostname}/css/form.css`} />
            : null}
        </I18nextProvider>
      </ThemeProvider>
    );
  }
}

App.propTypes = {
  auth: PropTypes.object.isRequired,
  budgetAuth: PropTypes.object.isRequired,
  unit: PropTypes.object,
  cms: PropTypes.object,
  theme: PropTypes.object,
  authActions: PropTypes.object.isRequired,
  budgetAuthActions: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    auth: state.auth,
    budgetAuth: state.budgetAuth,
    unit: state.unit,
    cms: state.cms,
    theme: state.theme,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    authActions: bindActionCreators(authActions, dispatch),
    budgetAuthActions: bindActionCreators(budgetAuthActions, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/components/App.js